import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border text-secondary spinner-border-sm",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-download-alt" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import postService from '@/services/post.services'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  className: {
    type: String,
    default: '',
  },
  fileDownloadName: {
    type: String,
    default: '',
  },
  communityId: String,
  postId: String,
  fromAdminSite: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const isDowloading = ref(false)

const handleDowloadFile = async (): void => {
  try {
    if (isDowloading.value) return

    isDowloading.value = true
    const response = await postService.getUrlDownload(props.communityId, props.postId, props.fromAdminSite)
    if (response?.data) {
      let blob = new Blob([response.data], { type: response.headers['content-type'] })
      const url = window.URL.createObjectURL(blob)
      const element = document.createElement('a')
      element.href = url
      element.download = props.fileDownloadName
      element.click()
    }
    isDowloading.value = false
  } catch (error) {
    isDowloading.value = false
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isDowloading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _withModifiers(handleDowloadFile, ["prevent"]),
          class: _normalizeClass(`${__props.className} text-decoration-none`),
          rel: "noopener noreferrer"
        }, _hoisted_6, 10, _hoisted_4))
  ]))
}
}

})